var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"logo-container"},_vm._l((_vm._partners),function(partner){return _c('div',{key:`partner-${partner.ETag}`,staticClass:"logo-item"},[_c('v-img',{attrs:{"src":`${_vm.$store.getters.bucket}/${partner.Key.replaceAll(' ','%20')}`}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }